module.exports = __webpack_public_path__ + "img/speech-to-text.3f51fb40.png";